<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>提现</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="cash-box">
                <div class="sub-content__title">
                    提现
                </div>
                <div class="cash-form">
                    <el-form ref="form" class="cash-form__inner" :model="form" style="width: 340px;" label-width="120px">
                        <el-form-item label="账户：">
                            <div>{{userInfo.company}}</div>
                        </el-form-item>
                        <el-form-item label="可提金额：">
                            <div><span class="text-danger" style="font-size: 14px;">{{userInfo.use_money}}</span>元</div>
                        </el-form-item>
                        <el-form-item label="收款银行：">
                            <el-button
                                v-if="userInfo.bank_card === ''"
                                type="text"
                                size="small"
                                @click="goPage('/index/info/modcard?handler=0')"
                            >
                                设置结算账户
                            </el-button>
                            <div
                                v-else
                                class="account-wrapper"
                            >
                                <div class="account-box">
                                    {{ userInfo.bank_name }} | 尾号 {{ tail }}
                                </div>
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="goPage('/index/info/modcard?handler=1')"
                                >
                                    修改
                                </el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="提现金额：">
                            <el-input v-model="form.money" placeholder="请输入提现金额"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button style="width: 120px;" size="small" type="primary" @click="cashSubmit">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="divider"></div>
            <div class="table" style="">
                <div class="sub-content__title">
                    提现记录
                </div>
                <el-table
                    :data="records"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="bank_card"
                        align="center"
                        label="提现银行账号">
                    </el-table-column>
                    <el-table-column
                        prop="bank_name"
                        align="center"
                        label="开户银行">
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        label="金额">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="申请提现时间">
                    </el-table-column>
                    <el-table-column
                        prop="execute_time"
                        align="center"
                        label="处理时间">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态">
                        <template slot-scope="scope">
                            {{statusList[scope.row.status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        align="center"
                        label="提现说明">
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :current-page="currentPage"
                        :page-size="20"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import router from '@/router'
import { mapState } from 'vuex'
export default {
    name: 'Index',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            userInfo: {},
            records: [],
            statusList: ['待处理', '成功', '失败'],
            total_page: 1,
            form: {
                money: ''
            }
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        }),
        tail () {
            let card = this.userInfo.bank_card || ''
            return card.substr(-4)
        }
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getUserInfo()
        this.getList()
    },
    methods: {
        cashSubmit () {
            if (this.form.money === '') {
                this.$message.error('请输入提现金额')
            } else if (!/^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(this.form.money)) {
                this.$message.error('请输入正确的提现金额')
            } else if ((this.form.money * 1) > (this.userInfo.use_money * 1)) {
                this.$message.error(`可提现金额不足`)
            } else if ((this.form.money * 1) < 0.01) {
                this.$message.error(`请输入正确的提现金额`)
            } else if (this.userInfo.bank_card === '') {
                this.$message.error(`请先设置结算账户`)
            } else {
                this.$confirm('即将操作提现, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.queryCash()
                })
            }
        },
        queryCash () {
            this.$http.post('/api/user/account/withdrawal', qs.stringify({
                money: this.form.money
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: '提现发起成功。'
                        })
                        router.replace('/index/finance/capital')
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getUserInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.userInfo = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        getList (page = this.currentPage) {
            this.$http.get('/api/user/account/withdrawallists', {
                params: {
                    page,
                    size: 10
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.records = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getList(e)
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";
    .data-overview {
        height: 78px;
    }
    .search-box {
        display: flex;
        height: unset !important;
        align-items: flex-end;
        .balance-box {
            margin-right: 55px;
            padding-left: 15px;
            .bd {
                line-height: 40px;
                font-size: 28px;
                margin-top: 20px;
            }
        }
    }
    .cash-box {
        padding: 0 15px 15px;
        .cash-form {
            border-top: 1px solid $--border-color-extra-light;
            padding-top: 15px;
            .cash-form__inner {
                .el-form-item {
                    margin-bottom: 10px;
                }
            }
        }
    }
    .sub-content__title {
        position: relative;
        color: $--color-primary;
        font-size: 14px;
        font-weight: 500;
        padding: 23px 0 20px 23px;

        &::before {
            content: "";
            width: 4px;
            height: 14px;
            background-color: $--color-primary;
            position: absolute;
            left: 0;
            top: 23px;
        }
    }
    .account-wrapper {
        display: flex;

        .account-box {
            border: 1px solid $--color-border-base;
            border-radius: 4px;
            padding: 0 20px;
            margin-right: 20px;
        }
    }
</style>
